module.exports = __webpack_public_path__ + "media/images/limits-topbar-4d58dabd078f8505e342dba9072b9bd1.svg";